const AUTH_RESPONSE_DATA_KEY = "authResponseData";

let memoryAuthResponseData = "";

function getStorageValue(storage, key) {
  try {
    return storage?.getItem?.(key) || "";
  } catch {
    return "";
  }
}

function setStorageValue(storage, key, value) {
  try {
    storage?.setItem?.(key, value);
    return storage?.getItem?.(key) === value;
  } catch {
    return false;
  }
}

function removeStorageValue(storage, key) {
  try {
    storage?.removeItem?.(key);
  } catch {}
}

function resolveStorage(overrides, name) {
  if (Object.prototype.hasOwnProperty.call(overrides, name)) return overrides[name];
  if (typeof window !== "undefined" && name in window) return window[name];
  return null;
}

function parseAuthResponse(raw) {
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function setAuthResponseData(rawValue, overrides = {}) {
  const value = String(rawValue || "");
  const localStorage = resolveStorage(overrides, "localStorage");
  const sessionStorage = resolveStorage(overrides, "sessionStorage");

  if (setStorageValue(localStorage, AUTH_RESPONSE_DATA_KEY, value)) {
    memoryAuthResponseData = value;
    return { storage: "local" };
  }
  if (setStorageValue(sessionStorage, AUTH_RESPONSE_DATA_KEY, value)) {
    memoryAuthResponseData = value;
    return { storage: "session" };
  }

  memoryAuthResponseData = value;
  return { storage: "memory" };
}

export function getRawAuthResponseData(overrides = {}) {
  const localStorage = resolveStorage(overrides, "localStorage");
  const sessionStorage = resolveStorage(overrides, "sessionStorage");
  return (
    getStorageValue(localStorage, AUTH_RESPONSE_DATA_KEY) ||
    getStorageValue(sessionStorage, AUTH_RESPONSE_DATA_KEY) ||
    memoryAuthResponseData ||
    ""
  );
}

export function getAuthResponseData(overrides = {}) {
  return parseAuthResponse(getRawAuthResponseData(overrides));
}

export function clearAuthResponseData(overrides = {}) {
  const localStorage = resolveStorage(overrides, "localStorage");
  const sessionStorage = resolveStorage(overrides, "sessionStorage");
  removeStorageValue(localStorage, AUTH_RESPONSE_DATA_KEY);
  removeStorageValue(sessionStorage, AUTH_RESPONSE_DATA_KEY);
  memoryAuthResponseData = "";
}
